module.exports = __webpack_public_path__ + "img/thumb-005-07.5893407f.png";